import { useEffect, useMemo } from 'react';
import { buildQuickActionPageGroups } from 'src/components/QuickActions/build-quick-action-page-groups';
import { useQuickActionsContext } from 'src/components/QuickActions/quick-actions-context';
import { useCustomViewTabs } from 'src/pages/CustomViews/hooks/use-view-tabs';
import { useNavTabVisibility } from 'src/utils/navigation/use-nav-tab-visibility';
import { useNavigationDestinations } from 'src/utils/navigation/use-navigation-destinations';

export const useQuickActionPages = () => {
  const { setPageGroups } = useQuickActionsContext();
  const { workspaceItems, favoriteViews, customViews, settingsGroups } =
    useNavigationDestinations();
  const { showInboxTab, showSearchTab, showSidekickTab } = useNavTabVisibility();
  const { tabs: viewTabs } = useCustomViewTabs();

  const pageGroups = useMemo(
    () =>
      buildQuickActionPageGroups({
        tabVisibility: { showInboxTab, showSearchTab, showSidekickTab },
        workspaceItems,
        favoriteViews,
        customViews,
        viewEntities: viewTabs.map((tab) => tab.entity),
        settingsGroups,
      }),
    [
      showInboxTab,
      showSearchTab,
      showSidekickTab,
      workspaceItems,
      favoriteViews,
      customViews,
      viewTabs,
      settingsGroups,
    ],
  );

  useEffect(() => {
    setPageGroups(pageGroups);
    return () => setPageGroups([]);
  }, [pageGroups, setPageGroups]);
};
